import { CMSResource } from "app/resources/cmsresource";
import { FooterUsefulContactsResource } from "./FooterUsefulContactsResource";
import { FooterAndKioskResource } from './ClientFooterAndKioskResource';

export class FooterResource extends CMSResource {

	rid: number;
	titleRo: string;
	titleFr: string;
	titleEn: string;
	titleDe: string;
	textColumn1Ro: string;
	textColumn1En: string;
	textColumn1Fr: string;
	textColumn1De: string;
	textColumn2Ro: string;
	textColumn2En: string;
	textColumn2Fr: string;
	textColumn2De: string;
	textColumn3Ro: string;
	textColumn3En: string;
	textColumn3Fr: string;
	textColumn3De: string;
	image: string;
	imageString: string;
	phone: string;
	contactEmail: string;
	userEmail: string;
	footerUsefulContactsResourceList: FooterUsefulContactsResource[];

	kioskResourceList: FooterAndKioskResource[];

	showDetailsOnResponsive: boolean = false;
	showDelete: boolean = false;
}
